export default __webpack_public_path__ + "static/media/OnlineConsultations.fef348db.svg";